import React, { PropsWithChildren, createContext, useContext, useEffect, useState } from 'react';
import { IFormData } from './Steps/interfaces';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider';

interface INotificationCentralContext {
  formData: IFormData;
  setFormData: React.Dispatch<React.SetStateAction<IFormData>>;
}

const NotificationCentralContext = createContext<INotificationCentralContext>({
  formData: {
    type: 'one_time',
    sendTo: 'all-users',
    emailsList: [],
    notificationType: 'email',
    emailSubject: '',
    html: '',
    emailTitle: '',
    emailBody: '',
    pushSubject: '',
    pushBody: '',
    promotions: [],
    date: '',
    daysOfWeek: [],
    time: '',
    agreement: null,
    users: [],
  },
  setFormData: () => {},
});

const NotificationCentralProvider: React.FC<PropsWithChildren> = ({ children }) => {


  const { id } = useTheme();

  const [formData, setFormData] = useState<IFormData>({
    sendTo: 'all-users',
    type: 'one_time',
    emailsList: [],
    notificationType: 'email',
    emailSubject: '',
    emailTitle: '',
    emailBody: '',
    pushSubject: '',
    html: '',
    pushBody: '',
    promotions: [],
    date: '',
    daysOfWeek: [],
    time: '',
    agreement: id,
    users: [],
  });
  useEffect(() => {
    setFormData({
      ...formData,
      agreement: id
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[id])

  return (
    // Step 3: Wrap your component tree with the context provider
    <NotificationCentralContext.Provider value={{ formData, setFormData }}>
      {children}
    </NotificationCentralContext.Provider>
  );
};

function useNotificationCentralContext() {
  return useContext(NotificationCentralContext);
}


export { NotificationCentralProvider, useNotificationCentralContext };
